<template>
  <div class="">
    <edit-treasury> </edit-treasury>
  </div>
</template>

<script>
import EditTreasury from "@/components/profile/treasuries-cash-references/treasury/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditTreasury,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({ text: "Modifica Conti", path: "treasuries.edit2", level: 3 });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Modifica Conto",
        path: "treasuries.edit2",
        level: 4,
      });
    }
  },
};
</script>
